/**
 * Bridge between the app-wide Pusher socket (usePusher) and anything that
 * needs to know the socket came back after a drop.
 *
 * While a mobile tab is backgrounded the browser suspends the websocket, so
 * Pusher events published in that window are never delivered. When Pusher
 * reconnects, usePusher re-emits that fact as a window CustomEvent; listeners
 * (e.g. the release-note watcher) use it to catch up via a REST fetch. Same
 * pattern as `messagingRealtime.ts`: one socket, no provider-ordering coupling.
 */

export const PUSHER_RECONNECTED_EVENT = "pagoda:pusher-reconnected";

/** Signal that the Pusher socket reconnected after an earlier connection. */
export function emitPusherReconnected(): void {
  window.dispatchEvent(new CustomEvent(PUSHER_RECONNECTED_EVENT));
}
